import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom'; 
import { ENDPOINT, DEFAULTLANGUAGE, LIMIT_PAGE, DEFAULT_TYPESDI } from "constants/variables"; 
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircleIcon from '@mui/icons-material/Circle';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EmailIcon from '@mui/icons-material/Email';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Grid from '@mui/material/Grid';
import PhoneIcon from '@mui/icons-material/Phone'; 
import Textarea from '@mui/joy/Textarea';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import "css/generalSettings.css";
import "css/empChips.css";
import "css/employeeHeader.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingAddress  from "pages/driver/driverEdit/SortingTablesAddress";
import DriverCreateOrEditAddress from "pages/driver/driverEdit/DriverNewAddress";
import DriverSelectUserAccount from "pages/driver/driverEdit/DriverSelectUserAccount";
import PropTypes from 'prop-types';
 
const initialStateDriver = {
  "id" : "",
  "firstname" : "",
  "lastname1" : "",
  "lastname2" : "",
  "fullname" : "", 
  "createdate":"",
  "enabled" : true,
  "birthdate" : null,
  "comments" : "",
  "useraccount_id":0,
  "useraccount_username": "",
  "useraccount_aliasuser": "",
  "useraccount_password": "",
  "useraccount_enabled": true,
  "useraccount_isAccountNonLocked": true,
  "useraccount_color_id": 0,
  "useraccount_color_codehex": "",
  "useraccount_store_id": 0,
  "useraccount_store_name": "",
  "useraccount_email": "",
  "useraccount_tyyesdi_id": 1,
  "useraccount_tyyesdi_namees": "",
  "useraccount_tyyesdi_nameen": "",  
  "documnettype_id":0,
  "numberdocument" : "",
  "numTotVehicles" : 0,
  "language_id":0,
  "extphone_id":"1",
  "phones" : [],
  "emails" : [],
  "addresses" : [],
};

const initialUserAccountToSelect = [{
  "useraccount_id":0,
  "useraccount_username": "",
  "useraccount_aliasuser": "",
  "useraccount_password": "",
  "useraccount_enabled": true,
  "useraccount_isAccountNonLocked": true,
  "useraccount_color_id": 0,
  "useraccount_color_codehex": "",
  "useraccount_store_id": 0,
  "useraccount_store_name": "",
  "useraccount_email": "",
  "useraccount_tyyesdi_id": 1,
  "useraccount_tyyesdi_namees": "",
  "useraccount_tyyesdi_nameen": ""
}];

const initialDocumentTypesToSelect = [{
  "id": "",
  "name": "",
  "entitycode":"F"
}]; 

const initialTypesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const initialExtInternationalToSelect = [{
  "id": "",
  "extphone": ""
}];

const initialAddresses = [{
  "id":"",
  "indexrowaddress":0,
  "street":"", 
  "defaultaddress": false,
  "fiscaladdress": false,
  "otherdata":"",
  "roadtype_id":0,
  "roadtype_namees":"",
  "roadtype_nameen":"",
  "postalcode_id":"",
  "postalcode_postalcodename":"",
  "community_id":6,
  "community_namees":"",
  "community_nameen":""
}];  

const DriverEditOrCreate = ({id, showModalDriverSettings}) => {
  const {t,i18n} = useTranslation(['listDataEmployees']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code);
  const DEFAULTEXTPHONE = useSelector((state) => state.formatDIUser.default_ext_phone); 
  const LIMITPHONEPEREMPLOYEE = useSelector((state) => state.formatDIUser.limitphoneperemployee); 
  const LIMITEMAILPEREMPLOYEE = useSelector((state) => state.formatDIUser.limitemailperemployee); 
  const LIMITADDRESSPEREMPLOYEE = useSelector((state) => state.formatDIUser.limitaddressperemployee);  
  const [formDriver, setFormDriver] = useState(initialStateDriver);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsDriver, setErrorsDriver] = useState({});
  const [foundNumberOfDocument, setFoundNumberOfDocument ]= useState(false); 
  const [newPhone,setNewPhone]= useState("");
  const [newEmail,setNewEmail]= useState(""); 
  const [openEditNewAddress,setOpenEditNewAddress]= useState(false);
  const [openDeleteRowAddress,setOpenDeleteRowAddress]= useState(false);
  const [openEditRowAddress,setOpenEditRowAddress]= useState(false);
  const [editRowAddress,setEditRowAddress]= useState(initialAddresses);
  const [idCodeDeleteAddress,setIdCodeDeleteAddress]=useState(DELETE_CODE);
  const [userAccountToSelect, setUserAccountToSelect]= useState(initialUserAccountToSelect);
  const [documentTypesToSelect,setDocumentTypesToSelect]= useState(initialDocumentTypesToSelect); 
  const [languagesToSelect,setLanguagesToSelect]= useState(initialTypesToSelect);
  const [openDeleteRowUserAccount,setOpenDeleteRowUserAccount]= useState(false);
  const [openSelectUserAccount,setOpenSelectUserAccount]= useState(false);
  const [idCodeDeleteUserAccount,setIdCodeDeleteUserAccount]=useState(DELETE_CODE);
  const [extInternationalToSelect,setExtInternationalToSelect]= useState(initialExtInternationalToSelect);
  const dispatch = useDispatch();
  const navigate = useNavigate();  
 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalDriverSettings) {
        setFormDriver(initialStateDriver);
        setFormDriver(formDriver => ({
          ...formDriver,
          phones:[],
          emails:[],
          addresses:[] 
        }));
        dispatch(setLoading(false));
        setIsLoadingErrorData(false);
        setErrorsDriver({});
        setFoundNumberOfDocument(false); 
        setNewPhone("");
        setNewEmail(""); 
         setOpenEditNewAddress(false);
        setOpenDeleteRowAddress(false);
        setOpenEditRowAddress(false);
        setEditRowAddress(initialAddresses);
        setIdCodeDeleteAddress(DELETE_CODE);
        setUserAccountToSelect(initialUserAccountToSelect);
        setDocumentTypesToSelect(initialDocumentTypesToSelect);
        setLanguagesToSelect(initialTypesToSelect); 
        setOpenDeleteRowUserAccount(false); 
        setOpenSelectUserAccount(false);
        setIdCodeDeleteUserAccount(DELETE_CODE);
        setExtInternationalToSelect(initialExtInternationalToSelect);
        navigate("/driver") 
        return () => {};
      }
    },
    [
      setFormDriver, 
      setIsLoadingErrorData,
      setErrorsDriver,
      setFoundNumberOfDocument, 
      setNewPhone,
      setNewEmail, 
       setOpenEditNewAddress,
      setOpenDeleteRowAddress,
      setOpenEditRowAddress,
      setEditRowAddress,
      setIdCodeDeleteAddress,
      setUserAccountToSelect,
      setDocumentTypesToSelect,
      setLanguagesToSelect,
      setOpenDeleteRowUserAccount,
      setOpenSelectUserAccount,
      setIdCodeDeleteUserAccount,
      setExtInternationalToSelect,
      showModalDriverSettings, 
      DELETE_CODE,
      dispatch,
      navigate]
  );
  
  const handleCloseDataEditDriver = () => {
    setFormDriver(initialStateDriver);
    setFormDriver(formDriver => ({
      ...formDriver,
      phones:[],
      emails:[],
      addresses:[]
    }));
    dispatch(setLoading(false));
    setIsLoadingErrorData(false);
    setErrorsDriver({});
    setFoundNumberOfDocument(false); 
    setNewPhone("");
    setNewEmail(""); 
    setOpenEditNewAddress(false);
    setOpenDeleteRowAddress(false);
    setOpenEditRowAddress(false);
    setEditRowAddress(initialAddresses);
    setIdCodeDeleteAddress(DELETE_CODE);
    setUserAccountToSelect(initialUserAccountToSelect);
    setDocumentTypesToSelect(initialDocumentTypesToSelect);
    setLanguagesToSelect(initialTypesToSelect);
    setOpenDeleteRowUserAccount(false);
    setOpenSelectUserAccount(false);
    setIdCodeDeleteUserAccount(DELETE_CODE);
    setExtInternationalToSelect(initialExtInternationalToSelect);
    navigate("/driver")
    return () => {};
	};

  const handleChangeEnabledDriver = (e) => {
    setFormDriver(formDriver => ({
        ...formDriver,
        enabled: !formDriver.enabled
    }));
  };

   const handleOpenSelectUserAccount = () => {
    setOpenSelectUserAccount(true);
  };

  const handleChangeDataEditDriver = (e) => {
    const { name, value } = e.target;
    setFormDriver(formDriver => ({
      ...formDriver,
      [name]: value,
    }));
    setFormDriver(formDriver => ({
      ...formDriver,
      fullname: formDriver.lastname1.toUpperCase()+' '+formDriver.lastname2.toUpperCase()+", "+formDriver.firstname.toUpperCase()
    }));  
  };

  const handleBlurDataEditDriver = (e) => {
    handleChangeDataEditDriver(e);
    setErrorsDriver(validateFormDriver());
  };
 
  const handleChangeSelectDocumentType = (event) => {
    setFormDriver(formDriver => ({
        ...formDriver,
        documnettype_id:event.target.value
    }));
  };

  const handleBlurSelectDocumentType = (e) => {
    handleChangeSelectDocumentType(e);
  };
   
  const handleChangeSelectLanguage = (event) => {
    setFormDriver(formDriver => ({
        ...formDriver,
        language_id:event.target.value
    }));
  };

  const handleBlurSelectLanguage = (e) => {
    handleChangeSelectLanguage(e);
    setErrorsDriver(validateFormDriver());
  };
   
  const handleChangeExtInternational = (event) => {
    setFormDriver(formDriver => ({
      ...formDriver,
      extphone_id:event.target.value
    }));
  }; 
  
  const handleBlurSelectExtInternational = (e) => {
    handleChangeExtInternational(e);
  };

  const handleChangeDefaultPhone = (item) => { 
    var i =  formDriver.phones.indexOf( item );
    formDriver.phones.map((item,index)=>{
      if ( index!==i ) {
        return item.defaultphone=false
      }else{
        return item.defaultphone=true
      }  
    })
    setFormDriver(formDriver => ({
      ...formDriver,
    }))
    setNewPhone("");
  };

  const handleDeletePhone = (item) => {
    var i =  formDriver.phones.indexOf( item );
    if ( i !== -1 ) {
      formDriver.phones.splice( i, 1 );
    }
    setFormDriver(formDriver => ({
      ...formDriver,
    }))
    if (item.defaultphone){
      if (formDriver.phones.length>0){
        formDriver.phones[0].defaultphone=true;
        setFormDriver(formDriver => ({
          ...formDriver,
        }))
      }
    }
    setNewPhone("");
  };
    
  const handleAddPhone = (event) => {  
    
    setErrorsDriver(validateFormDriver());
    if (errorsDriver.newPhone===undefined && newPhone!=="") {
      let defaultFound=false;
      if (formDriver.phones.length<=0){
        defaultFound=true;
      }
      let phoneToAdd={
        "id":"",
        "phone":reformatPhone(newPhone),
        "defaultphone":defaultFound
      }
      formDriver.phones.push(phoneToAdd);
      setNewPhone("");
    }
  };

  function reformatPhone(phone){

    phone=phone.replace(/[^0-9]+/g, "").replace(" ", "").toUpperCase();
    if (phone.length<9){
        for (let i = phone.length; i < 9; i++) {
            phone="0"+phone;
        }
    }
    let invertString = "";
    for (let indice = phone.length - 1; indice >= 0; indice--) {
        invertString += phone.charAt(indice);
    }
    phone = "";
    
    for (let indice = 8; indice >= 0; indice--) {
        phone += invertString.charAt(indice);
        if (indice===2 || indice===4) phone += ".";
        if (indice===6 ) phone += "-";
    }
   
    if (extInternationalToSelect!==undefined && extInternationalToSelect!==null && extInternationalToSelect.length>0){
      let extPhone=extInternationalToSelect.find((key)=>(key.id===Number(formDriver.extphone_id))).extphone;
      return extPhone+" "+phone;
    } else {
      return phone;
    }
  }

  const handleChangeNewPhone = (event) => {
    setNewPhone(event.target.value);
  };
  
  const handleBlurNewPhone = (e) => {
    handleChangeNewPhone(e);
    setErrorsDriver(validateFormDriver());
  };

  const handleChangeDefaultEmail = (item) => {
    var i =  formDriver.emails.indexOf( item );
    formDriver.emails.map((item,index)=>{
      if ( index!==i ) {
        return item.defaultemail=false
      }else{
        return item.defaultemail=true
      }  
    })
    setFormDriver(formDriver => ({
       ...formDriver,
    }))
    setNewEmail("");
   };
 
  const handleDeleteEmail = (item) => {
    var i =  formDriver.emails.indexOf( item );
    if ( i !== -1 ) {
      formDriver.emails.splice( i, 1 );
    }
    setFormDriver(formDriver => ({
      ...formDriver,
    }))
    if (item.defaultemail){
      if (formDriver.emails.length>0){
        formDriver.emails[0].defaultemail=true;
        setFormDriver(formDriver => ({
          ...formDriver,
        }))
      }
    }
    setNewEmail("");
  };
 
  const handleAddEmail = () => {  
    if (errorsDriver.newEmail===undefined  && newEmail!=="") {
      let defaultFound=false;
      if (formDriver.emails.length===0){
        defaultFound=true;
      }
      const emailToAdd={
        "id":"",
        "email":newEmail,
        "defaultemail":defaultFound
      }
      formDriver.emails.push(emailToAdd)
      setNewEmail("");
    }  
  };

  const handleChangeNewEmail = (event) => {
    setNewEmail(event.target.value);
  };
  
  const handleBlurNewEmail = (e) => {
    handleChangeNewEmail(e);
    setErrorsDriver(validateFormDriver());
  };

  const handleChangeDeleteRowAddress = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteAddress(value);
  };

  const handleCancelDeleteRowAddress = () => {
    setIdCodeDeleteAddress(DELETE_CODE);
    setOpenDeleteRowAddress(false);
  };

  const handleCloseDeleteRowAddress = (e) => {
    e.preventDefault();
    if (idCodeDeleteAddress!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formDriver.addresses.findIndex(((item) => item.indexrowaddress === editRowAddress.indexrowaddress));
      if ( indexDelete !== -1 ) {
        formDriver.addresses.splice( indexDelete, 1 );
      }
      setFormDriver(formDriver => ({
        ...formDriver,
      }))
      if (editRowAddress.defaultaddress){
        if (formDriver.addresses.length>0){
          formDriver.addresses[0].defaultaddress=true;
          setFormDriver(formDriver => ({
            ...formDriver,
          }))
        }
      }
      if (editRowAddress.fiscaladdress){
        if (formDriver.addresses.length>0){
          formDriver.addresses[0].fiscaladdress=true;
          setFormDriver(formDriver => ({
            ...formDriver,
          }))
        }
      }
      setIdCodeDeleteAddress(DELETE_CODE);
      setOpenDeleteRowAddress(false);
    }
  };
  
  const handleChangeDeleteRowUserAccount = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteUserAccount(value);
  };

  const handleCancelDeleteRowUserAccount = () => {
    setIdCodeDeleteUserAccount(DELETE_CODE);
    setOpenDeleteRowUserAccount(false);
  };

  const handleCloseDeleteRowUserAccount = (e) => {
    e.preventDefault();
    if (idCodeDeleteUserAccount!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      setFormDriver(formDriver => ({
        ...formDriver,
        useraccount_id:0,
        useraccount_username:"",
        useraccount_aliasuser:"",
        useraccount_password:"",
        useraccount_enabled:true,
        useraccount_isAccountNonLocked:true,
        useraccount_color_id:0,
        useraccount_color_codehex:"",
        useraccount_store_id:0,
        useraccount_store_name:"",
        useraccount_email:"",
        useraccount_tyyesdi_id:Number(DEFAULT_TYPESDI),
        useraccount_tyyesdi_namees:"",
        useraccount_tyyesdi_nameen:"" 
      }));
      setIdCodeDeleteUserAccount(DELETE_CODE);
      setOpenDeleteRowUserAccount(false);
    }
  };

  const validateFormDriver = () => {
    let errorsDriver = {}; 
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (!formDriver.firstname || formDriver.firstname==="") {
      errorsDriver.firstname = 'Text_FieldFirstnameRequired'; 
    } else {
      if (regexInvalidCharacters.test(formDriver.firstname)) {
        errorsDriver.firstname = 'Text_TextNoValid';
      }
    }    
    if (!formDriver.lastname1 || formDriver.lastname1==="") {
      errorsDriver.lastname1 = 'Text_FieldLastnameRequired';
    }else {
      if (regexInvalidCharacters.test(formDriver.lastname1)) {
        errorsDriver.lastname1 = 'Text_TextNoValid';
      }
    }  
    if (regexInvalidCharacters.test(formDriver.lastname2)) {
      errorsDriver.lastname2 = 'Text_TextNoValid';
    }

    if (formDriver.numberdocument!== undefined && formDriver.numberdocument!==""){
      if (regexInvalidCharacters.test(formDriver.numberdocument)) {
        errorsDriver.numberdocument = 'Text_TextNoValid';
      }else{
        if (foundNumberOfDocument){
          errorsDriver.numberdocument='Text_FieldnumberdocumentExist';
        }
      }
    }
     
    if (formDriver.language_id===undefined || formDriver.language_id===null ||formDriver.language_id==="" || formDriver.language_id===0 || formDriver.language_id==="0") {
       errorsDriver.language_id = 'Text_FieldLanguageRequired';
    }
    if (newPhone!=="") {
      if (formDriver.phones.find(obj => {return obj.phone ===reformatPhone(newPhone)})){
        errorsDriver.newPhone = 'Text_Employee_Phone';
      } else {
        if (formDriver.phones.length>=Number(LIMITPHONEPEREMPLOYEE)){
          errorsDriver.newPhone = 'Text_Employee_Phones_Length';
        } else {
          if (newPhone.length<=8){
            errorsDriver.newPhone = 'Text_Employee_Phone_Length';
          } 
        }
      }
    }
    if (newEmail!=="") {
      if (formDriver.emails.find(obj => {return obj.email ===newEmail})){
        errorsDriver.newEmail = 'Text_Employee_Email';
      } else {
        if (formDriver.emails.length>=Number(LIMITEMAILPEREMPLOYEE)){
          errorsDriver.newEmail = 'Text_Employee_Emails_Length';
        } else {
          if (newEmail.length<=8){
            errorsDriver.newEmail = 'Text_Employee_Email_Length';
          }
        }
      }
    }
    return errorsDriver;
  };

  const handleSubmitDataEditDriver = () => {
    const errors = validateFormDriver();
    setErrorsDriver(errors); 
    if ((Object.keys(errors).length === 0) && formDriver.firstname!==''  && formDriver.lastname1!==''  
        && formDriver.language_id!==undefined && formDriver.language_id!==null 
        && formDriver.language_id!=='' && formDriver.language_id!=='0' && formDriver.language_id!==0) {
      handleCloseDataEditDriver();
      const fetchData = async () => {  
        try {
          const getData = id !== "0"
            ? await helpHttp().put(ENDPOINT, `driver/updatedriver`, token, formDriver)
            : await helpHttp().post(ENDPOINT, `driver/savedriver`, token, formDriver);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData'))); 
          } 
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }  
        return () => {};
      }; 
      fetchData();
    } else {
      if (errors.firstname) {
        dispatch(warningErrorAction(t(errors.firstname)));
      } else if (errors.lastname1) {
        dispatch(warningErrorAction(t(errors.lastname1)));
      } else if (errors.numberdocument) {
        dispatch(warningErrorAction(t(errors.numberdocument)));
      } else if (errors.language_id) {
        dispatch(warningErrorAction(t(errors.language_id)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
     const fetchExistNumberDocument = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `driver/getdriverbynumberdocument/`, token,formDriver.numberdocument.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setFoundNumberOfDocument(getData!==formDriver.id && getData>0)
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formDriver.numberdocument && formDriver.numberdocument.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocument();
    } 
    return () => {};
  }, [t,token,dispatch,i18n,formDriver.id,formDriver.numberdocument]);
 
  useEffect(() => { 
    const fetchDataUserAccount = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `driver/useraccountsdriverorderbyusername`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setUserAccountToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataLanguage = async () => {
      try {
        const getData = i18n.language==="es"
            ?await helpHttp().get(ENDPOINT, `language/languagesorderbynamees`, token)
            :await helpHttp().get(ENDPOINT, `language/languagesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else  {
          setLanguagesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataDocumentType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `documenttype/simpledocumenttypesbyname`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setDocumentTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
 
    const fetchDataExtInternational = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `country/simplephonesextinternational`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else  {
          setExtInternationalToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
  
    if (formDriver.id!==null ){
      fetchDataDocumentType();
      fetchDataLanguage();
      fetchDataUserAccount();
      if (roles[0].listmenus.find((key)=>(key.name==='Handle_Driver_Add_Phone'))){
        fetchDataExtInternational();
      }
    }
    return () => { };

  }, [t,token,dispatch,i18n,roles,formDriver.id,showModalDriverSettings]);
 
useEffect(() => {
  let isMounted = true;
  const fetchDataDriver = async () => {
    dispatch(setLoading(true));
    try {
      const getData = await helpHttp().get2(ENDPOINT, `driver/searchdriverbyid/`, token, id);
      if (getData.err || getData.message === "Load failed") {
        if (isMounted) {
          setFormDriver(initialStateDriver);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        }
      } else if (isMounted) {
        setFormDriver(getData);
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t('Text_IncorrectData'))); 
    }  
  };
  if (id !== "0") {
    if (formDriver.id === "") {
      fetchDataDriver();
    }
  } else {
    setFormDriver(initialStateDriver);
    setFormDriver(formDriver => ({
      ...formDriver,
      documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
      language_id:Number(DEFAULTLANGUAGE),
      extphone_id:Number(DEFAULTEXTPHONE),
      phones:[],
      emails:[],
      addresses:[]
    }));
    dispatch(setLoading(false));
  }
  return () => { isMounted = false };

}, [dispatch,id,t,token,formDriver.id,isLoadingData,DEFAULTEXTPHONE,DEFAULTTYPEOFDOCUMENT]); 
 
 return (
      <>
        {showModalDriverSettings ? ( 
          <div className="container-fluid formgeneral-send-wrapper">
            <Box sx={{ bgcolor: '#ffffff', width: '1600px'}}>
              <form onSubmit={handleCloseDataEditDriver}>  
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {isLoadingErrorData?
                      <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                      (isLoadingData?
                      <CircularProgress sx={{ color : "#f6c23e"}}/>:
                      <i className={formDriver.enabled?"fas fa-regular fa-address-card fa text-warning":"fas fa-regular fa-address-card fa text-dark"}></i>)} 
                      &nbsp;&nbsp;{formDriver.fullname}
                    </div>
                    <div className="email-card-actions">
                      {!isLoadingData && (
                        <>
                          <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditDriver} >
                            {id==="0"?t('Button_Create'):t('Button_Update')}
                          </button>
                          <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditDriver} >
                            {t('Button_Cancel')}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <br/>

                {/* FORM CARD */}
                {!isLoadingData ?
                <>
                  <div className="empgrid">
                     {/* ===== ID del Driver ===== */}
                    <div className="emp-col-2">
                      <div className={`empcard empcard--info ${!formDriver.enabled ? "empcard--disabled empcard--strike" : ""}`}>
                        <Typography className="empcard-title">{t("Text_Id")}</Typography>
                        <Typography className="empcard-value" style={{fontSize: 26}}>
                          {id === "0" ? t("Text_New") : formDriver.id}
                        </Typography>
                      </div>
                    </div>

                    {/* ===== Habilitado / Deshabilitado ===== */}
                    {roles[0].listmenus.find(k => k.name === "Handle_Employee_Hability") && (
                      <div className="emp-col-2">
                        <div className="empcard empcard--info">
                          <Typography className="empcard-title">
                            {formDriver.enabled ? t("Text_enabled_Upper") : t("Text_disabled")}
                          </Typography>

                          <div className="mt-8">
                            <button
                              type="button"
                              className={`empbtn empbtn-outline`}
                              onClick={handleChangeEnabledDriver}
                              title={formDriver.enabled ? t("Button_DISABLED") : t("Button_ENABLED")}
                            >
                              {formDriver.enabled ? t("Button_DISABLED") : t("Button_ENABLED")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ===== Cuenta de usuario ===== */}
                    {(roles[0].listmenus.find(k => k.name === "Handle_Employee_Add_UserAccount")
                    || roles[0].listmenus.find(k => k.name === "Handle_Employee_Modify_UserAccount")
                    || roles[0].listmenus.find(k => k.name === "Handle_Employee_Enabled_UserAccount")
                    || roles[0].listmenus.find(k => k.name === "Handle_Employee_Delete_UserAccount")) ? (
                      <div className="emp-col-8">
                        <div className={`empcard empcard--info empcard--wide ${!formDriver.enabled ? "empcard--disabled empcard--strike" : ""}`}>
                          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
                            <div>
                              <Typography className="empcard-title">{t("Text_userAccount")}</Typography>
                              <Typography className="empcard-value">
                                {(!formDriver.useraccount_username)
                                  ? `<< ${t("Text_New_UserAccount")} >>`
                                  : (
                                    <>
                                      <IconButton size="small" style={{color: formDriver.useraccount_color_codehex}}>
                                        <CircleIcon />
                                      </IconButton>
                                      &nbsp;{formDriver.useraccount_username}
                                    </>
                                  )
                                }
                              </Typography>
                            </div>

                            <div className="empcard-actions">
                              {(!formDriver.useraccount_username)
                                ? (roles[0].listmenus.find(k => k.name === "Handle_Employee_Enabled_UserAccount") &&
                                  <button
                                    type="button"
                                    className={`empbtn ${formDriver.enabled ? "empbtn-primary" : "empbtn-disabled"}`}
                                    onClick={formDriver.enabled ? () => handleOpenSelectUserAccount() : undefined}
                                  >
                                    {t("Button_userAccount_Select")}
                                  </button>)
                                : (
                                  <>
                                    {(roles[0].listmenus.find(k => k.name === "Handle_Employee_Enabled_UserAccount") && userAccountToSelect.length > 0) &&
                                      <button
                                        type="button"
                                        className={`empbtn ${formDriver.enabled ? "empbtn-primary" : "empbtn-disabled"}`}
                                        onClick={formDriver.enabled ? () => handleOpenSelectUserAccount() : undefined}
                                      >
                                        {t("Button_userAccount_Select")}
                                      </button>
                                    }
                                    {roles[0].listmenus.find(k => k.name === "Handle_Employee_Delete_UserAccount") &&
                                      <button
                                        type="button"
                                        className={`empbtn ${formDriver.enabled ? "empbtn-danger" : "empbtn-disabled"}`}
                                        onClick={formDriver.enabled ? () => setOpenDeleteRowUserAccount(!openDeleteRowUserAccount) : undefined}
                                      >
                                        {t("Button_userAccount_Delete")}
                                      </button>
                                    }
                                  </>
                                )
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="emp-col-4">
                        <div className={`empcard empcard--info ${!formDriver.enabled ? "empcard--disabled empcard--strike" : ""}`}>
                          <Typography className="empcard-title">{t("Text_userAccount")}</Typography>
                          <Typography className="empcard-value" style={{fontSize: 20}}>
                            {(!formDriver.useraccount_username) ? `<< ${t("Text_New_UserAccount")} >>` : formDriver.useraccount_username}
                          </Typography>
                        </div>
                      </div>
                    )}
                  </div> 
                  <br/> 

                  <div className="formgeneral-card-form">
                    <div className="email-header-title3">{t('Text_Personal_Data')}</div> 
                    <hr className="sidebar-divider d-none d-md-block"/>
                      <div className="row p-2">
                        <div className="form-group">   
                          <h6 className={formDriver.enabled?"h3NewStyle mb-2":"h3NewStyleDark"}>{t('Text_Personal_Data')}</h6>
                          {/* Divider */}
                          <hr className="sidebar-divider d-none d-md-block"/>
                          <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_firstname')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="firstname" 
                            name="firstname"
                            value={formDriver.firstname}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            inputProps={{ style: {width: 300, fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 100 }}
                            label={errorsDriver.firstname!=null?t(errorsDriver.firstname):t('PlaceHolder_Driver_firstname')}
                            placeholder={t('PlaceHolder_Driver_firstname')}
                            variant="standard"
                            onBlur={formDriver.enabled?handleBlurDataEditDriver:() => {}}
                            onChange={formDriver.enabled?handleChangeDataEditDriver:() => {}}/>
                          {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                          <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_lastname1')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp;  
                          <TextField
                            id="lastname1" 
                            name="lastname1"
                            value={formDriver.lastname1}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            inputProps={{ style: {width: 400, fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 100 }}
                            label={errorsDriver.lastname1!=null?t(errorsDriver.lastname1):t('PlaceHolder_Driver_lastname1')}
                            placeholder={t('PlaceHolder_Driver_lastname1')}
                            variant="standard"
                            onBlur={formDriver.enabled?handleBlurDataEditDriver:() => {}}
                            onChange={formDriver.enabled?handleChangeDataEditDriver:() => {}}/>
                          {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                          <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_lastname2')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="lastname2" 
                            name="lastname2"
                            value={ formDriver.lastname2!== null ? formDriver.lastname2:""}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            inputProps={{ style: {width: 400, fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 100 }}
                            label={errorsDriver.lastname2!=null?t(errorsDriver.lastname2):t('PlaceHolder_Driver_lastname2')}
                            placeholder={t('PlaceHolder_Driver_lastname2')}
                            variant="standard"
                            onBlur={formDriver.enabled?handleBlurDataEditDriver:() => {}}
                            onChange={formDriver.enabled?handleChangeDataEditDriver:() => {}}/>
                        </div>
                      </div>

                      <div className="row p-2"> 
                        <div className="form-group">
                          <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_documenttype')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="documnettype_id"
                            name="documnettype_id"
                            value={ (formDriver.documnettype_id === undefined || formDriver.documnettype_id ===null || formDriver.documnettype_id ===""
                                  || formDriver.documnettype_id ==="0" || formDriver.documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formDriver.documnettype_id}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            inputProps={{ style: {width: 165, fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 100 }}
                            variant="outlined"
                            onBlur={formDriver.enabled?handleBlurSelectDocumentType:() => {}}
                            onChange={formDriver.enabled?handleChangeSelectDocumentType:() => {}}
                            select
                            SelectProps={{
                                native: true,
                                value: (formDriver.documnettype_id === undefined || formDriver.documnettype_id ===null || formDriver.documnettype_id ===""
                                    || formDriver.documnettype_id ==="0" || formDriver.documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formDriver.documnettype_id
                                }}>
                                <option key={0} value=""/>
                                {documentTypesToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.name}
                                </option>
                                ))}
                          </TextField>  
                          {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                          <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_document')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="numberdocument" 
                            name="numberdocument"
                            value={ formDriver.numberdocument!== null ? formDriver.numberdocument:""}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            inputProps={{ style: {width: 400, fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 100 }}
                            label={errorsDriver.numberdocument!=null?t(errorsDriver.numberdocument):t('PlaceHolder_DocumenType')}
                            placeholder={t('PlaceHolder_DocumenType')}
                            variant="standard"
                            onBlur={formDriver.enabled?handleBlurDataEditDriver:() => {}}
                            onChange={formDriver.enabled?handleChangeDataEditDriver:() => {}}>
                          </TextField>
                          {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                          <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_language')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="language_id"
                            name="language_id"
                            value={ (formDriver.language_id === undefined || formDriver.language_id ===null || formDriver.language_id ===""
                                  || formDriver.language_id ==="0" || formDriver.language_id ===0)?Number(DEFAULTLANGUAGE):formDriver.language_id}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            inputProps={{ style: {width: 200, fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 100 }}
                            variant="outlined"
                            onBlur={formDriver.enabled?handleBlurSelectLanguage:() => {}}
                            onChange={formDriver.enabled?handleChangeSelectLanguage:() => {}}
                            select
                            SelectProps={{
                              native: true,
                              value: (formDriver.language_id === undefined || formDriver.language_id ===null || formDriver.language_id ===""
                                  || formDriver.language_id ==="0" || formDriver.language_id ===0)?Number(DEFAULTLANGUAGE): formDriver.language_id
                            }}>
                            {languagesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                            ))}
                          </TextField> 
                        </div>
                      </div>
                      <div className="row p-2"> 
                        <div className="form-group">  
                        <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Comments')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp;   
                        <Textarea 
                          id="comments" 
                          name="comments"
                          value={formDriver.comments}
                          label={errorsDriver.comments!=null?t(errorsDriver.comments):t('PlaceHolder_Comments')}
                          placeholder={t('PlaceHolder_Comments')}
                          sx={{width: i18n.language==="es"?1560:1560, fontSize: 18} }
                          variant="standard"
                          onBlur={formDriver.enabled?handleBlurDataEditDriver:() => {}}
                          onChange={formDriver.enabled?handleChangeDataEditDriver:() => {}}
                          maxRows={8}
                        />
                        </div>
                      </div> 

                      {roles[0].listmenus.find((key)=>(key.name==='Handle_Driver_Add_Phone'))&&
                        <div className="row p-2"> 
                          <div className="form-group">
                          <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Ext_Default')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="extphone_id"
                            name="extphone_id"
                            value={ (formDriver.extphone_id === undefined || formDriver.extphone_id ===null || formDriver.extphone_id ===""
                                  || formDriver.extphone_id ==="0" || formDriver.extphone_id ===0)?Number(DEFAULTEXTPHONE):formDriver.extphone_id}
                            style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            inputProps={{ style: {width: 100, fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through' }, maxLength: 10, }}
                            variant="outlined"
                            onBlur={formDriver.enabled?handleBlurSelectExtInternational:() => {}}
                            onChange={formDriver.enabled?handleChangeExtInternational:() => {}}
                            select
                            SelectProps={{
                                native: true,
                                value: (formDriver.extphone_id === undefined || formDriver.extphone_id ===null || formDriver.extphone_id ===""
                                      || formDriver.extphone_id ==="0" || formDriver.extphone_id ===0)?Number(DEFAULTEXTPHONE): formDriver.extphone_id
                                }}>
                                {extInternationalToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.extphone}
                                </option>
                                ))}
                          </TextField>
                        </div>
                      </div>
                      }
                      <Box sx={{ bgcolor:'#fff', width:'100%' }}> 
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={4}>
                            <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_phones')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            {roles[0].listmenus.find((key)=>(key.name==='Handle_Driver_Add_Phone'))?
                            <TextField
                              id="newPhone" 
                              name="newPhone"
                              value={newPhone}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              inputProps={{style: {width: 250,  fontSize: 18,textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 20}}
                              InputProps={{ 
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PhoneIcon  style={{fontSize: 28}}/>
                                </InputAdornment>
                                ),
                              }}
                              label={errorsDriver.newPhone!=null?t(errorsDriver.newPhone):t('PlaceHolder_NewPhone')}
                              placeholder={t('PlaceHolder_NewPhone')}
                              variant="standard"
                              onBlur={formDriver.enabled?handleBlurNewPhone:() => {}}
                              onChange={formDriver.enabled?handleChangeNewPhone:() => {}}>
                            </TextField>:<></>}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='Handle_Driver_Add_Phone'))?
                              <IconButton
                                size="small"  
                                onClick={formDriver.enabled?handleAddPhone:() => {}}>
                                <Icon
                                  baseClassName="fas"
                                  className={formDriver.enabled?"fa-plus add-icon-button":"fa-plus add-deleteicon-button"}
                                />  
                              </IconButton>:<></>
                            }
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <div className="empchips-wrap">
                              {formDriver.phones.map((element, index) => (
                                <Chip
                                  key={index}
                                  className={[
                                    "empchip3",
                                    element.defaultphone ? "empchip3--default" : "",
                                    !formDriver.enabled ? "empchip3--disabled" : "",
                                  ].join(" ")}
                                  icon={<PhoneIcon />}
                                  label={
                                    <>
                                      {element.phone}
                                      {element.defaultphone && <span className="empchip3-badge">{t('Text_By_Default')}</span>}
                                    </>
                                  }
                                  clickable
                                  onClick={
                                    roles[0].listmenus.find(k => k.name==='Handle_Driver_Default_Phone') && formDriver.enabled
                                      ? () => handleChangeDefaultPhone(element)
                                      : undefined
                                  }
                                  onDelete={
                                    roles[0].listmenus.find(k => k.name==='Handle_Driver_Delete_Email') && formDriver.enabled
                                      ? () => handleDeletePhone(element) 
                                      : undefined}
                                />
                              ))}
                            </div>
                          </Grid>
                        </Grid>
                      </Box>
                      <br/>
                      <Box sx={{ bgcolor:'#fff', width:'100%' }}> 
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={4}>
                            <label className={formDriver.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_emails')} :</label>
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            {roles[0].listmenus.find((key)=>(key.name==='Handle_Driver_Add_Email'))?
                              <TextField
                                id="newEmail" 
                                name="newEmail"
                                type="email"
                                value={newEmail}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                inputProps={{style: {width: 250,fontSize: '18px', textDecorationLine:formDriver.enabled?'none':'line-through'}, maxLength: 75}}
                                InputProps={{ 
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <EmailIcon style={{fontSize: 28}}/>
                                  </InputAdornment>
                                  ),
                                }}
                                label={errorsDriver.newEmail!=null?t(errorsDriver.newEmail):t('PlaceHolder_NewEmail')}
                                placeholder={t('PlaceHolder_NewEmail')}
                                variant="standard"
                                onBlur={formDriver.enabled?handleBlurNewEmail:() => {}}
                                onChange={formDriver.enabled?handleChangeNewEmail:() => {}}>
                              </TextField>:<></>}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              {roles[0].listmenus.find((key)=>(key.name==='Handle_Driver_Add_Email'))?
                                <IconButton
                                  size="small"  
                                  onClick={formDriver.enabled?handleAddEmail:() => {}}>
                                  <Icon
                                    baseClassName="fas"
                                    className={formDriver.enabled?"fa-plus add-icon-button":"fa-plus add-deleteicon-button"}
                                  />  
                                </IconButton>:<></> 
                              }
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <div className="empchips-wrap">
                              {formDriver.emails.map((element, index) => (
                                <Chip
                                  key={index}
                                  className={[
                                    "empchip3",
                                    element.defaultemail ? "empchip3--default" : "",
                                    !formDriver.enabled ? "empchip3--disabled" : "",
                                  ].join(" ")}
                                  icon={<EmailIcon />}
                                  label={
                                    <>
                                      {element.email}
                                      {element.defaultemail && <span className="empchip3-badge">{t('Text_By_Default')}</span>}
                                    </>
                                  }
                                  clickable
                                  onClick={
                                    roles[0].listmenus.find(k => k.name==='Handle_Driver_Default_Email') && formDriver.enabled
                                      ? () => handleChangeDefaultEmail(element)
                                      : ()=>{}
                                  }
                                  onDelete={
                                    roles[0].listmenus.find(k => k.name==='Handle_Driver_Default_Email') && formDriver.enabled
                                      ? () => handleDeleteEmail(element) 
                                      : ()=>{}
                                    }
                                />
                              ))}
                            </div>
                          </Grid>
                        </Grid>
                      </Box> 
                      <br/>
                      <div className="formdi-pending-card-flat">
                        <div className="formdi-pending-card-content">
                          <TableSortingAddress 
                            dataAddress={formDriver.addresses} 
                            setFormDriver={setFormDriver}
                            checkedRow={formDriver.enabled}
                            numTotRegAddress={formDriver.addresses.length}
                            setOpenDeleteRowAddress={setOpenDeleteRowAddress}
                            setOpenEditNewAddress={setOpenEditNewAddress}
                            setOpenEditRowAddress={setOpenEditRowAddress}
                            setEditRowAddress={setEditRowAddress}
                            roles={roles}
                            LIMITPAGESIZE={LIMIT_PAGE}
                            LIMITADDRESSPEREMPLOYEE={LIMITADDRESSPEREMPLOYEE.toString()}
                          />
                          <DriverCreateOrEditAddress 
                              openEditRowAddress={openEditRowAddress}
                              setOpenEditRowAddress={setOpenEditRowAddress} 
                              openEditNewAddress={openEditNewAddress} 
                              setOpenEditNewAddress={setOpenEditNewAddress}
                              formDriver={formDriver}
                              setFormDriver={setFormDriver}
                              editRowAddress={editRowAddress}
                              setEditRowAddress={setEditRowAddress}
                            />
                        </div>
                      </div>   
                    </div> 
                  </>:
                <LoadingNews/> 
              }
            </form>
          </Box>
          <br/> 
           <div>
            <DriverSelectUserAccount 
              openSelectUserAccount={openSelectUserAccount}
              setOpenSelectUserAccount={setOpenSelectUserAccount} 
              formDriver={formDriver}
              setFormDriver={setFormDriver}
              userAccountToSelect={userAccountToSelect}
            />
          </div>
         
          <div>
            <Dialog open={openDeleteRowAddress} onClose={handleCancelDeleteRowAddress} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {editRowAddress.indexrowaddress} - {i18n.language==="es"?editRowAddress.roadtype_namees:editRowAddress.roadtype_nameen} {editRowAddress.street} {editRowAddress.number} {editRowAddress.floor}  {editRowAddress.door}
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDeleteAddress}
                      onChange={handleChangeDeleteRowAddress}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRowAddress}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRowAddress}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>    
          </div> 
          <div>
            <Dialog open={openDeleteRowUserAccount} onClose={handleCancelDeleteRowUserAccount} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {formDriver.useraccount_id} - {formDriver.useraccount_username}
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDeleteUserAccount}
                      onChange={handleChangeDeleteRowUserAccount}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRowUserAccount}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRowUserAccount}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>   
          </div>
        </div>
      //* End Page Content *//
    ) :  null }
  </>
  )    
}

DriverEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalDriverSettings: PropTypes.bool.isRequired 
};

export default DriverEditOrCreate;